import webkitLineClamp from "webkit-line-clamp";

interface ShopSearchOptions {
    url?: string;
}

const LOADING_HTML = `
    <div class="d-flex align-items-center justify-content-center flex-column my-5 gap-2">
        <div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"></div>
        <span class="fs-3">Lade Suchergebnisse...</span>
    </div>
    <div class="no-results d-none">
        <p>Tut uns leid - leider wurde kein passendes Ergebnis zu Ihrer Suche gefunden!</p>
    </div>
    <div class="error d-none">
        <p>Tut uns leid - es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.</p>
    </div>
`;

function getSearchTerm(): string | null {
    const params = new URLSearchParams(window.location.search);
    return params.get('searchterm') ?? params.get('search');
}

function parseDatasetOptions(dataset: DOMStringMap): Record<string, string> {
    const parsed: Record<string, string> = {};
    
    for (const [key, value] of Object.entries(dataset)) {
        if (value === undefined) continue;
        
        const newKey = key.startsWith('shopSearch')
            ? key.replace(/^shopSearch/, '').replace(/^./, c => c.toLowerCase())
            : key;
        parsed[newKey] = value;
    }
    
    return parsed;
}

function applyLineClamp(container: HTMLElement): void {
    const lines = container.querySelectorAll<HTMLElement>('.croppedLines');
    
    lines.forEach((line) => {
        const lineCrop = line.dataset.linecrop;
        if (lineCrop) {
            webkitLineClamp(line, parseInt(lineCrop, 10));
        }
    });
}

export async function ShopSearch(element: HTMLElement, options: ShopSearchOptions = {}): Promise<void> {
    element.innerHTML = LOADING_HTML;

    const defaults: ShopSearchOptions = {
        url: '/?standalone=Avency.Nwd.Base:Content.ProductSearch&searchterm={searchTerm}'
    };

    const datasetOptions = parseDatasetOptions(element.dataset);
    const opts = { ...defaults, ...datasetOptions, ...options };

    const searchTerm = getSearchTerm();

    if (!searchTerm) {
        element.querySelector('.no-results')?.classList.remove('d-none');
        return;
    }

    try {
        const url = opts.url!.replace('{searchTerm}', encodeURIComponent(searchTerm));
        const response = await fetch(url);
        
        if (!response.ok) {
            throw new Error(`HTTP ${response.status}`);
        }
        
        element.innerHTML = await response.text();
        applyLineClamp(element);
        document.dispatchEvent(new Event('plandent.reinit.bootstrapTabs'));
    } catch (error) {
        console.error('ShopSearch Fehler:', error);
        element.querySelector('.error')?.classList.remove('d-none');
    }
}

document.querySelectorAll<HTMLElement>('[data-shop-search="init"]').forEach((element) => {
    ShopSearch(element);
});
